var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.avatarStyle)},[_c('img',{staticClass:"img-fluid h-100",attrs:{"src":_vm.avatarUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }